module.exports = __webpack_public_path__ + "86dd4197bc664e69cc2dcba53bd2e6bc.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibold.woff2
// module id = 693
// module chunks = 57